// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2dr9t","buttons":"RemoveExpirationActionButtons_buttons__2_cpW"};